<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import trainingAPI from "@/services/standards/preventionbrigade/trainingAPI";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal"
import Pagination from "@/components/standard/preventionbrigade/preventionTrainingPagination";
import { sendNotification } from "@/utils/helpers/notification"
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import ItemAPI from "@/services/items/itemsAPI";


/**
 * Form elements component
 */
export default {

  page: {
    title: "5.1.2 Brigada de emergencias",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    CheckModal,
    PageHeader,
    Pagination,
  },
  data() {

    return {
      title: "5.1.2 Brigada de emergencias",
      items: [

        {
          text: "Estándares",
          href: "/",
        },
        {
          text: "5.1.2 Brigada de emergencias",
          active: true,
        },
      ],
      userSelected: null,
      usersList: [],
      lista: [],
      item: null,
      itemData: null,
      file: null,
      listaII: null,
      training: {
        title: null,
        video: null,
        description: null,
      },
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      search: "",
      loading: true,
      submitted: false,
      loading1: true,
    };
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(52)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },


    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },


    /**
   * This method is used to knows if the user has the permission indicated
   * @param {String} name The name of the permission
   * @param {Array} roles the roles that permitted to access the action 
   * @returns {Boolean} true if the user has the permission indicated or false if no
   */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getList() {
      trainingAPI.getAllTraining()
        .then((response) => {
          this.lista = response.Pb_training.data;
          this.loading1 = false

        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false
        });
    },

    save() {
      this.submitted = true
      this.loading = true
      trainingAPI.save(this.training)
        .then((response) => {
          this.loading1 = false
          setTimeout(() => {
            Swal.fire({
              title: "¡Éxito!",
              text: "¡Se ha registrado con éxito!",
              type: "success",
              icon: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }, 1500)
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    deleteMedicine(id) {
      OcupationalMedicineAPI.deleteMedicine(id)
        .then((data) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha sido eliminado con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 52)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

  },

  mounted() {
    this.getList();
    this.getItems()
    this.getItemData();
  },
};
</script>

<template>

  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">

      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">
          <div class="card">
            <div class="card-body">

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">

                  <b-form-group label-for="titulo" class="col-md-6 px-2" label="Título capacitacion">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" type="text" id="date_exam" maxlength="100"
                      v-model="training.title">
                    </b-form-input>
                  </b-form-group>

                <b-form-group label-for="video" class="col-md-6 px-2" label="Video capacitación">
                  <b-form-input :disabled="!getRole('Crear')  || !allowAccess()" type="text" id="date_exam" v-model="training.video">
                  </b-form-input>
                </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Descripción" label-for="file">
                    <b-form-textarea :disabled="!getRole('Editar') || !allowAccess()" type="date" id="note" maxlength="200"
                      v-model="training.description">
                    </b-form-textarea>
                  </b-form-group>

                </div>

              <div class="form-group text-right m-b-0">
                <button type="submit" class="btn btn-primary " :disabled="!getRole('Crear')  || !allowAccess()">
                  Guardar
                </button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                  Cancelar
                </button>
              </div>

                <hr v-if="getRole('Consultar') || !allowAccess()" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <div class="form-row row text-center">
                            <form @submit.prevent="fetch()" class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                  class="form-control px-2" placeholder="Buscar"></b-form-input>
                              </div>
                              <div class="col-sm-1 pl-5">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>

                            </form>
                          </div>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <div v-if="!loading">
                          <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                            <thead>
                              <tr>
                                <th class="text-center align-middle">Título de la capacitacion</th>
                                <th class="text-center align-middle">Video</th>
                                <th class="text-center align-middle">Descripción</th>
                                <th class="text-center align-middle">Acciones</th>
                              </tr>
                            </thead>

                            <tbody class="bg-white divide-y divide-gray-200">
                              <tr v-for="dato in lista" :key="dato.id">
                                <td class="text-center align-middle">
                                  {{ dato.title }}
                                </td>
                                <td class="text-center align-middle">
                                  <a :href="dato.video">{{ dato.video }}</a>
                                </td>

                                <td class="text-center align-middle">
                                  {{ dato.description }}
                                </td>

                                <td class="text-center align-middle">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/brigada-prevencion-capacitacion-ver/${dato.id}` }">Ver</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/brigada-prevencion-capacitacion-editar/${dato.id}` }">Editar</b-dropdown-item>
                                  </b-dropdown>

                                </td>
                              </tr>

                            </tbody>
                          </table>
                        </div>
                        <div v-else>
                          <div class="text-center pt-2">
                            <b-spinner variant="primary" label="Loading..."></b-spinner>
                          </div>
                        </div>
                        <div>
                          <Pagination @loading="(load) => (loading = load)" ref="paginator" :search="search"
                            @fetch="(items) => (lista = items)" />
                        </div>

                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>